import { IoIosClose } from "react-icons/io";
import { MdDone } from "react-icons/md";
import { Formik, Field, Form } from "formik";
import css from "./SelectStatusModal.module.css";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import {
  getAllArchiveData,
  returnArchiveItem,
} from "../../../redux/archive/operations";
import { useSelector } from "react-redux";
import { selectDates } from "../../../redux/crm/selectors";
import { useLocation } from "react-router-dom";
import {
  getAllCars,
  getCarsByDate,
  getCurrentCars,
} from "../../../redux/cars/operations";
import { getClientsInWork } from "../../../redux/accounting/operations";
import { selectChosenPeriod } from "../../../redux/accounting/selectors";
import { useEffect } from "react";
import { showToast } from "../../../utils/showToast.js";
import { selectDate } from "../../../redux/cars/selectors.js";

const returnStatus = [
  {
    id: "1",
    statusClass: css.yellow,
    statusText: "НОВА",
    statusMapping: "new",
    background: "var(--status-gradient-new)",
    borderColor: "var(--border-gradient-new)",
  },
  {
    id: "2",
    statusClass: css.lightBlue,
    statusText: "ДІАГНОСТИКА",
    statusMapping: "diagnostic",
    background: "var(--status-gradient-archive-light-blue)",
    borderColor: "var(--border-gradient-diag)",
  },
  {
    id: "3",
    statusClass: css.violet,
    statusText: "РЕМОНТ",
    statusMapping: "repair",
    background: "var(--status-gradient-archive-violet)",
    borderColor: "var(--border-gradient-repair)",
  },
  {
    id: "5",
    statusClass: css.green,
    statusText: "ЗАВЕРШЕНО",
    statusMapping: "complete",
    background: "var(--status-gradient-complete)",
    borderColor: "var(--border-gradient-complete)",
  },
];

export default function SelectStatusModal({ onClose, id }) {
  const dispatch = useDispatch();
  const dates = useSelector(selectDates);
  const actualDate = useSelector(selectDate);
  const accountingDates = useSelector(selectChosenPeriod);
  const location = useLocation();
  const isCrmPage = location.pathname === "/crm";
  const isVideoControlPage = location.pathname === "/video-control";
  const isInWorkPage = location.pathname === "/accounting/clients";

  const handleSubmit = async values => {
    if (!values.status) {
      showToast("Будь ласка, оберіть статус.", "error");
      return;
    }

    const selectedStatus = returnStatus.find(
      status => status.id === values.status
    );

    if (!selectedStatus) {
      showToast("Статус не знайдено.", "error");
      return;
    }

    const newStatus = selectedStatus.statusMapping;

    const itemData = {
      archive_id: id,
      status: newStatus,
    };

    try {
      await dispatch(returnArchiveItem(itemData))
        .unwrap()
        .then(() => {
          if (isVideoControlPage) {
            dispatch(getCurrentCars());
            dispatch(getAllCars({ view: "monitoring", to_date: actualDate }));
          } else if (isCrmPage) {
            dispatch(getAllCars({ view: "planner", to_date: dates.endDate, from_date: dates.startDate }));
          } else if (isInWorkPage) {
            console.log("isInWorkPage", isInWorkPage);
            dispatch(getClientsInWork(accountingDates));
          }
          dispatch(getAllArchiveData());
        });
      // await dispatch(getRecordsForPeriod(dates));
      showToast("Запис успішно відновлено!", "success");
      onClose();
    } catch (error) {
      showToast(`Помилка: ${error.message || error}`, "error");
    }
  };

  return (
    <div className={css.wrapper}>
      <button className={css.exitBtn} onClick={onClose}>
        <IoIosClose className={css.icon} />
      </button>

      <Formik initialValues={{ status: "" }} onSubmit={handleSubmit}>
        {({ values }) => {
          const selectedStatus = returnStatus.find(
            status => status.id === values.status
          );

          return (
            <Form className={css.form}>
              <label htmlFor="status">
                Оберіть статус для відновлення з архіву:
              </label>
              <Field
                as="select"
                id="status"
                name="status"
                className={`${css.select} ${
                  selectedStatus ? selectedStatus.statusClass : ""
                }`}
                style={{
                  background: selectedStatus
                    ? selectedStatus.background
                    : undefined,
                  borderColor: selectedStatus
                    ? selectedStatus.borderColor
                    : undefined,
                }}
              >
                <option value="" disabled>
                  Оберіть статус...
                </option>
                {returnStatus.map(status => (
                  <option key={status.id} value={status.id}>
                    {status.statusText}
                  </option>
                ))}
              </Field>

              <div className={css.btnsGroup}>
                <button
                  type="button"
                  className={css.closeBtn}
                  onClick={onClose}
                >
                  Закрити
                </button>
                <button type="submit" className={css.submitBtn}>
                  <MdDone />
                  Підтвердити
                </button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}
